import * as actionsTypes from '../actions/actionsTypes';
import { updateObject } from '../../utils/utils';

const initialState = {
  loadingTopRated: false,
  trending: [],
  topRated: [],
  upcoming: [],
  popular: [],
  nowPlaying: []
};

const fetchUpcoming = (state, action) => {
  return updateObject(state, { upcoming: action.payload });
};

const fetchTopRated = (state, action) => {
  return updateObject(state, {
    topRated: action.payload,
    loadingTopRated: false
  });
};

const fetchTopRatedPending = (state, action) => {
  return updateObject(state, {
    topRated: [],
    loadingTopRated: true
  });
};

const fetchPopular = (state, action) => {
  return updateObject(state, { popular: action.payload });
};

const fetchNowPlaying = (state, action) => {
  return updateObject(state, { nowPlaying: action.payload });
};

const fetchTrending = (state, action) => {
  return updateObject(state, { trending: action.payload });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.FETCH_UPCOMING_FULFILLED:
      return fetchUpcoming(state, action);
    case actionsTypes.FETCH_TOP_RATED_PENDING:
      return fetchTopRatedPending(state, action);
    case actionsTypes.FETCH_TOP_RATED_FULFILLED:
      return fetchTopRated(state, action);
    case actionsTypes.FETCH_POPULAR_FULFILLED:
      return fetchPopular(state, action);
    case actionsTypes.FETCH_NOW_PLAYING_FULFILLED:
      return fetchNowPlaying(state, action);
    case actionsTypes.FETCH_TRENDING_FULFILLED:
      return fetchTrending(state, action);

    default:
      return state;
  }
};

export default reducer;
